import { render, staticRenderFns } from "./zifuchuan.vue?vue&type=template&id=4d43c7cd&scoped=true"
import script from "./zifuchuan.vue?vue&type=script&lang=ts"
export * from "./zifuchuan.vue?vue&type=script&lang=ts"
import style0 from "./zifuchuan.vue?vue&type=style&index=0&id=4d43c7cd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43c7cd",
  null
  
)

export default component.exports